// Shared Google Maps script loader utility using module pattern
const createGoogleMapsLoader = () => {
    let loadPromise = null;
    let isLoaded = false;
    let isLoading = false;

    const load = () => {
        // Return existing promise if already loading
        if (loadPromise) {
            return loadPromise;
        }

        // Return resolved promise if already loaded
        if (isLoaded || window.google?.maps) {
            isLoaded = true;
            return Promise.resolve();
        }

        // Start loading
        isLoading = true;
        loadPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS}&libraries=places&v=weekly&loading=async`;
            script.async = true;
            
            script.onload = () => {
                // Wait for Google Maps and places library to be fully initialized
                const checkGoogleMaps = () => {
                    if (window.google && window.google.maps && window.google.maps.places) {
                        isLoaded = true;
                        isLoading = false;
                        resolve();
                    } else {
                        // Retry after a short delay
                        setTimeout(checkGoogleMaps, 100);
                    }
                };
                checkGoogleMaps();
            };
            
            script.onerror = () => {
                isLoading = false;
                loadPromise = null; // Allow retry
                reject(new Error('Failed to load Google Maps script'));
            };
            
            document.head.appendChild(script);
        });

        return loadPromise;
    };

    const isGoogleMapsLoaded = () => {
        return isLoaded || Boolean(window.google?.maps?.places);
    };

    return {
        load,
        isGoogleMapsLoaded
    };
};

// Export a singleton instance
export const googleMapsLoader = createGoogleMapsLoader(); 